enum Rounded {
  None = 'none',
  Xxs = '2xs',
  Xs = 'xs',
  Sm = 'sm',
  Md = 'md',
  Lg = 'lg',
  Xl = 'xl',
  Xxl = '2xl',
  Max = 'max',
}

export const RoundedValues = [Rounded.None, Rounded.Xxs, Rounded.Xs, Rounded.Sm, Rounded.Md, Rounded.Lg, Rounded.Xl, Rounded.Xxl, Rounded.Max]

export const SkeletonConfig = {
  Rounded,
}
